import React from "react";
import styles from "./ComplianceSupport.module.scss";
import DocShareSVG from "./DocShareSVG";
import CustomDocSVG from "./CustomDocSVG";
import TechDrivenSVG from "./TechDrivenSVG";

const complianceItems = [
  {
    id: 1,
    icon: DocShareSVG,
    subtitle: "Automated Document Sharing",
    description: "Batch CoAs and SDSs delivered with every shipment",
  },
  {
    id: 2,
    icon: CustomDocSVG,
    subtitle: "On-Demand Custom Docs",
    description: "For customer-specific country or certification needs",
  },
  {
    id: 3,
    icon: TechDrivenSVG,
    subtitle: "Tech-Driven Systems",
    description: "Versioning, audit trails & quick access via platform",
  },
];

const ComplianceItem = ({ complianceItem }) => {
  return (
    <div className={styles.complianceItem}>
      {/* Icon */}
      {complianceItem.icon()}
      {/* Subtitle */}
      <div className={styles.subtitle}>{complianceItem.subtitle}</div>
      {/* Description */}
      <div className={styles.description}>{complianceItem.description}</div>
    </div>
  );
};

function ComplianceSupport() {
  return (
    <div className={styles.complianceSupport}>
      {/* Small Heading  */}
      {/* <h6>CAPTION TEXT</h6> */}
      {/* Big Heading */}
      <h2>How do we support compliance?</h2>
      {/* Radial Gradient */}
      <div className={styles.centerGradient}></div>
      {/* Compliance Items Row */}
      <div className={styles.complianceRow}>
        {complianceItems.map((complianceItem) => (
          <ComplianceItem
            key={complianceItem.id}
            complianceItem={complianceItem}
          />
        ))}
      </div>
    </div>
  );
}

export default ComplianceSupport;
